import React, { useState, useEffect } from "react";
import { Box, Button, Text } from "@chakra-ui/react";
import { DateRange } from "react-date-range";
import { addYears, format } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { enUS } from "date-fns/locale";

const CustomDateRangePicker = ({ onApply, dateRange, setDateRange }) => {
  const [range, setRange] = useState([
    {
      startDate: dateRange?.fromDate || new Date(),
      endDate: dateRange?.toDate || new Date(),
      key: "selection",
    },
  ]);

  // Update range when dateRange prop changes (for new setDateRange usage)
  useEffect(() => {
    if (dateRange?.fromDate && dateRange?.toDate) {
      setRange([
        {
          startDate: new Date(dateRange.fromDate),
          endDate: new Date(dateRange.toDate),
          key: "selection",
        },
      ]);
    }
  }, [dateRange?.fromDate, dateRange?.toDate]);

  const handleSelect = (ranges) => {
    setRange([ranges.selection]);
  };

  const handleApply = () => {
    const fromDate = format(range[0].startDate, "yyyy-MM-dd");
    const toDate = format(range[0].endDate, "yyyy-MM-dd");
    
    // Support both old onApply callback and new setDateRange function
    if (onApply) {
      onApply({ fromDate, toDate });
    }
    if (setDateRange) {
      setDateRange({
        fromDate: range[0].startDate,
        toDate: range[0].endDate,
      });
    }
  };

  return (
    <Box p={4} bg="white" borderRadius="md" shadow="sm">
      <Text mb={2} fontWeight="bold">Select Custom Date Range</Text>
      <DateRange
        ranges={range}
        onChange={handleSelect}
        moveRangeOnFirstSelection={false}
        maxDate={addYears(new Date(), 1)}
        locale={enUS}
      />
      <Box mt={2}>
        <Text fontSize="sm" color="gray.600">
          From: {format(range[0].startDate, "dd MMM yyyy")}
        </Text>
        <Text fontSize="sm" color="gray.600">
          To: {format(range[0].endDate, "dd MMM yyyy")}
        </Text>
      </Box>
      <Button mt={3} colorScheme="orange" size="sm" onClick={handleApply}>
        Apply Filter
      </Button>
    </Box>
  );
};

export default CustomDateRangePicker;
